import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "flex w-full justify-between items-center pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h6", { class: "font-semibold text-xl text-black" }, "Serah Terima Barang", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReceiveItemForm = _resolveComponent("ReceiveItemForm")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "dialog-confirm",
    visible: _ctx.dialogForm,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogForm = $event)),
    dismissableMask: true,
    modal: true,
    onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideForm()))
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("i", {
          class: "pi pi-times text-black cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideForm()))
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_ReceiveItemForm, {
        id: _ctx.id,
        onSuccessBack: _ctx.submitSuccess,
        onHideForm: _ctx.hideForm
      }, null, 8, ["id", "onSuccessBack", "onHideForm"])
    ]),
    _: 1
  }, 8, ["visible"]))
}